import * as actions from "../action.constants";

const sendAddUserModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_ADD_USER_DATA_SAGA,
  payload: data,
  callback,
});
const requestUsers = (pageUrl) => ({
  type: actions.REQUEST_GET_USERS_LIST_SAGA,
  pageUrl,
});
const saveUsersList = (data) => ({
  type: actions.SAVE_GET_USERS_LIST,
  payload: data,
});

const sendEditUserModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_EDIT_USER_DATA_SAGA,
  payload: data,
  callback,
});

const deleteUserData = (id, callback) => ({
  type: actions.REQUEST_DELETE_USER_SAGA,
  payload: id,
  callback,
});

const requestUserProfile = () => ({
  type: actions.GET_USER_PROFILE,
});

const saveUserProfile = (data) => ({
  type: actions.STORE_USER_PROFILE,
  payload: data,
});

const requestCustomerUserProfile = () => ({
  type: actions.GET_CUSTOMER_USER_PROFILE,
});

const saveCustomerUserProfile = (data) => ({
  type: actions.STORE_CUSTOMER_USER_PROFILE,
  payload: data,
});

const requestOrgUsers = () => ({
  type: actions.REQUEST_ORG_USERS,
});

const storeOrgUsers = (data) => ({
  type: actions.STORE_ORG_USERS,
  payload: data,
});

const changeOwner = (data, callback) => ({
  type: actions.CHANGE_OWNER,
  payload: data,
  callback,
});

const requestUserResources = () => ({
  type: actions.REQUEST_USER_RESOURCES,
});

const saveUserResources = (data, callback) => ({
  type: actions.STORE_USER_RESOURCES,
  payload: data,
  callback,
});

const saveUserSettings = (data) => ({
  type: actions.SAVE_USER_SETTINGS,
  payload: data,
});

export {
  sendAddUserModalData,
  requestUsers,
  saveUsersList,
  sendEditUserModalData,
  deleteUserData,
  requestUserProfile,
  saveUserProfile,
  requestCustomerUserProfile,
  saveCustomerUserProfile,
  requestOrgUsers,
  storeOrgUsers,
  changeOwner,
  requestUserResources,
  saveUserResources,
  saveUserSettings,
};
